import { Metrohoudai } from '@linktivity/link-connect';
import config from '../config';

const LoginApi = new Metrohoudai.LoginApi(config);

export default LoginApi;
